import React from 'react';
import { Link } from 'gatsby';
import clsx from 'clsx';
import parse from 'html-react-parser';
import { IconLink } from '~/icons';
import { isUrlValid } from '~/utils';
import * as styles from './Card.module.scss';

const Wrapper = React.memo(({ children, href, className, ...other }) => {
  const isUrl = isUrlValid(href);

  return isUrl ?
    (
      <a href={href} target="_blank" rel="noopener noreferrer" className={clsx(styles.wrapper, className)} {...other}>
        {children}
      </a>
    ) : (
      <Link to={href} className={clsx(styles.wrapper, className)} {...other}>
        {children}
      </Link>
    );
});

const Card = React.forwardRef((props, ref) => {
  const {
    href,
    tag,
    description,
    disabled,
    className,
    children,
    ...other
  } = props;

  return (
    <Wrapper href={href} className={className} {...other}>
      <div className={styles.toolbar}>
        <button type="button" className={styles.anchor} disabled={disabled}>
          <IconLink />
        </button>
        <p className={styles.tag}>{tag}</p>
      </div>
      <div className={styles.figure}>
        {children}
      </div>
      <footer className={styles.footer}>
        <p className={styles.text}>{parse(description)}</p>
      </footer>
    </Wrapper>
  );
});

export default React.memo(Card);
